module.exports = __webpack_public_path__ + "media/images/static/top/local/ローカルMV -aa42025cdaa901fb8fe562163c2afc83.png";